
// ******************
//
// Ver.1.0
// Released on: Nov 15, 2023
// Phase 1.5
//
// ******************
import Vue from 'vue'
import { regex } from '@/shared/regex'
import { WrappedFormUtils } from 'ant-design-vue/types/form/form'
import TitlePopup from '@/components/common_new/popup/title.vue'
import InputCustom from '@/components/common_new/input/index.vue'
import { IDataAddMail } from '@/modules/advisor/shared/@types'
import { ListNamePopup } from '@/shared/enums'
import { mapGetters } from 'vuex'
import ButtonCustom from '@/components/common_new/button-custom/index.vue'
import { scrollToFirstErrorLineForm } from '@/shared/function'

type IDataEditAddMail = {
    formAddMail: WrappedFormUtils
    titlePopup: string
    btnReceiveEmail: string
}

export default Vue.extend({
    name: 'AddMailProvider',
    components: { InputCustom, TitlePopup, ButtonCustom },
    computed: {
        ...mapGetters('popup', ['getParamsPopup']),
        ...mapGetters('signupAdvisor', ['getRoleEditAdvisor'])
    },
    data(): IDataEditAddMail {
        return {
            formAddMail: this.$form.createForm(this, {
                name: 'form_add_email'
            }),
            titlePopup: '受信用メールアドレスの登録',
            btnReceiveEmail: this.$tc('i18n_add_mail_btn_register')
        }
    },
    mounted() {
        if (this.getParamsPopup) {
            const { name, email } = this.getParamsPopup
            this.formAddMail.setFieldsValue({
                name,
                email,
                emailConfirm: email
            })
            this.titlePopup = '登録済みメールアドレスの編集'
            this.btnReceiveEmail = '更新'
        }
    },
    methods: {
        onClosePopup() {
            this.backToMailList()
        },
        onSubmitForm() {
            this.formAddMail.validateFields(
                (errors: Error[], values: IDataAddMail) => {
                    if (errors) {
                        scrollToFirstErrorLineForm()
                        return
                    }
                    this.onPostAddMail(values)
                }
            )
        },
        async onPostAddMail(payload: IDataAddMail) {
            this.getParamsPopup
                ? (payload = Object.assign(payload, {
                      id: this.getParamsPopup.id
                  }))
                : ''
            const res = await this.$store.dispatch(
                'signupProvider/editAddMailProvider',
                payload
            )
            if (res === 'success') {
                this.formAddMail.resetFields()
                this.backToMailList()
            }
            return
        },
        backToMailList() {
            this.$store.dispatch('popup/openPopup', {
                isOpen: true,
                namePopup: ListNamePopup.MailListProvider
            })
        },
        validName() {
            return [
                {
                    required: true,
                    message: this.$tc(
                        'i18n_provider_AddMailProvider_name_required'
                    )
                },
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if (value) {
                            if (regex.space_full.test(value))
                                return callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_name_space_full'
                                    )
                                )
                            if (!regex.length20.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_name_length20'
                                    )
                                )
                                return
                            }
                        }
                        callback()
                    }
                }
            ]
        },
        ruleValidEmail() {
            return [
                {
                    required: true,
                    message: this.$tc(
                        'i18n_provider_AddMailProvider_email_required'
                    )
                },
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if (value) {
                            if (!regex.length255.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_email_length255'
                                    )
                                )
                                return
                            }
                            if (!regex.email.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_email'
                                    )
                                )
                                return
                            }
                            if (!regex.lengthNameEmail.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_email_lengthNameEmail'
                                    )
                                )
                                return
                            }
                            const emailNewConfirm =
                                this.formAddMail.getFieldValue('emailConfirm')
                            if (emailNewConfirm) {
                                if (emailNewConfirm !== value) {
                                    this.formAddMail.validateFields([
                                        'emailConfirm'
                                    ])
                                    return
                                }
                                if (emailNewConfirm === value) {
                                    this.formAddMail.validateFields([
                                        'emailConfirm'
                                    ])
                                }
                            }
                        }
                        callback()
                    }
                }
            ]
        },
        validPassNewConfirm() {
            return [
                {
                    required: true,
                    message: this.$tc(
                        'i18n_provider_AddMailProvider_EmailConfirm_required'
                    )
                },
                {
                    validator: (rule: any, value: any, callback: any) => {
                        if (value) {
                            if (!regex.length255.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_EmailConfirm_length255'
                                    )
                                )
                                return
                            }
                            if (!regex.email.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_EmailConfirm_email'
                                    )
                                )
                                return
                            }
                            if (!regex.lengthNameEmail.test(value)) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_EmailConfirm_lengthNameEmail'
                                    )
                                )
                                return
                            }
                            const email =
                                this.formAddMail.getFieldValue('email')
                            if (email && email !== value) {
                                callback(
                                    this.$tc(
                                        'i18n_provider_AddMailProvider_EmailConfirm_same'
                                    )
                                )
                                return
                            }
                        }
                        callback()
                    }
                }
            ]
        }
    }
})
